import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import vegaLogo from "../../../images/vega-logo.svg";
import LanguageDropDown from "./items/LanguageDropDown";
import NotAuthUserDropDown from "./items/NotAuthUserDropDown";
import CurrencyDropDown from "./items/CurrencyDropDown";
import AuthUserDropDown from "./items/AuthUserDropDown";
import NotificationBell from "./items/NotificationBell";
import { useAuth } from "../../../hooks/useAuth";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { BsThreeDots } from "react-icons/bs";
import { useState } from "react";
import "./TopNavbar.scss";

const TopNavbar = () => {
    const { session } = useAuth();
    const isMobile = useMediaQuery("(max-width: 575px)");
    const [showMenu, setShowMenu] = useState(false);

    const navItems = (
        <>
            {session && <NotificationBell />}
            <CurrencyDropDown />
            <LanguageDropDown />
            {session ? (
                <AuthUserDropDown userEmail={session.email} onAction={() => setShowMenu(false)} />
            ) : (
                <NotAuthUserDropDown onAction={() => setShowMenu(false)} />
            )}
        </>
    );

    return (
        <>
            <Navbar className="top-bar" data-bs-theme="dark">
                <Container fluid>
                    <Navbar.Brand href="/" className="topBar-logo">
                        <img src={vegaLogo} alt="logo" className="d-inline-block align-top" />
                    </Navbar.Brand>

                    {isMobile ? (
                        <button
                            className="top-bar__menu-btn"
                            onClick={() => setShowMenu(true)}
                            aria-label="Open menu"
                        >
                            <BsThreeDots color="white" size={24} />
                        </button>
                    ) : (
                        <Nav className="ms-auto">{navItems}</Nav>
                    )}
                </Container>
            </Navbar>

            {isMobile && (
                <Offcanvas
                    show={showMenu}
                    onHide={() => setShowMenu(false)}
                    placement="bottom"
                    className="top-bar-offcanvas"
                    data-bs-theme="dark"
                >
                    <Offcanvas.Header closeButton />
                    <Offcanvas.Body>
                        <Nav className="top-bar-offcanvas__list">{navItems}</Nav>
                    </Offcanvas.Body>
                </Offcanvas>
            )}
        </>
    );
};
export default TopNavbar;
